import React, { useState } from 'react';

const KEY = 'cookieNoticeOk';

// Tells visitors about the audience-measurement cookies (Google Analytics and our own
// visitor counter). Shown until dismissed; the choice is remembered in this browser.
const CookieNotice = () => {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  });
  if (hidden) return null;

  const dismiss = () => {
    setHidden(true);
    try { localStorage.setItem(KEY, '1'); } catch (e) { /* storage blocked */ }
  };

  return (
    <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:max-w-sm z-30 bg-gray-900 text-white text-sm rounded-xl shadow-lg p-4 flex items-start gap-3">
      <p className="flex-1">
        Ce site utilise des cookies de mesure d'audience pour compter les visites et améliorer le service.
        {' '}<a href="/legal-mentions" className="underline text-gray-300">En savoir plus</a>
      </p>
      <button type="button" onClick={dismiss} className="shrink-0 bg-white text-gray-900 font-semibold rounded-lg px-3 py-1.5">
        OK
      </button>
    </div>
  );
};

export default CookieNotice;
